'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('react-datepicker/dist/react-datepicker.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _onChangeHookGenerator = require('../../helpers/onChangeHookGenerator');

var _onChangeHookGenerator2 = _interopRequireDefault(_onChangeHookGenerator);

var _translate = require('../../../v2/language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a date picker.
 * @extends {Component}
 */
var DatePickerComponent = function (_React$Component) {
  _inherits(DatePickerComponent, _React$Component);

  function DatePickerComponent() {
    _classCallCheck(this, DatePickerComponent);

    return _possibleConstructorReturn(this, (DatePickerComponent.__proto__ || Object.getPrototypeOf(DatePickerComponent)).apply(this, arguments));
  }

  _createClass(DatePickerComponent, [{
    key: 'getDateOrNull',
    value: function getDateOrNull() {
      return this.isDateValid() ? (0, _moment2.default)(this.props.field.value) : null;
    }
  }, {
    key: 'isDateValid',
    value: function isDateValid() {
      return this.props.field.value && !this.isDateOutOfBounds();
    }
  }, {
    key: 'isDateOutOfBounds',
    value: function isDateOutOfBounds() {
      return (0, _moment2.default)(this.props.field.value).isBefore(this.props.minDate, 'day') || (0, _moment2.default)(this.props.field.value).isAfter(this.props.maxDate, 'day');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_reactDatepicker2.default, _extends({}, this.props, {
        placeholderText: (0, _translate.t)('Please select...'),
        className: 'ingle-form-date-picker form-control',
        name: this.props.field.name,
        dropdownMode: 'select',
        disabled: this.props.disabled,
        dateFormat: this.props.format,
        onChange: (0, _onChangeHookGenerator2.default)(function (value) {
          if (value) {
            return _this2.props.field.onChange(value.format(_this2.props.format));
          }
          return value;
        }, this.props.onChangeHook),
        selected: this.props.defaultDate || this.getDateOrNull()
      }));
    }
  }]);

  return DatePickerComponent;
}(_react2.default.Component);

DatePickerComponent.propTypes = {
  format: _react2.default.PropTypes.string,
  field: _react2.default.PropTypes.object.isRequired,
  minDate: _react2.default.PropTypes.object.isRequired,
  maxDate: _react2.default.PropTypes.object.isRequired,
  onChangeHook: _react2.default.PropTypes.func,
  disabled: _react2.default.PropTypes.bool,
  defaultDate: _react2.default.PropTypes.object
};
DatePickerComponent.defaultProps = {
  format: 'YYYY-MM-DD'
};
exports.default = DatePickerComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/DatePickerComponent.jsx
// module id = 52
// module chunks = 0